import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Mail, Phone } from "lucide-react";
import BrandLogo from "./BrandLogo";
import SocialIcons from "./SocialIcons";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        {/* Brand + description + social */}
        <div className="md:col-span-5">
          <BrandLogo variant="light" size="lg" testid="footer-logo" />
          <p className="mt-6 text-sm text-white/65 max-w-md leading-relaxed">
            A bespoke inbound agency, made in Indonesia. We design slow,
            considered journeys for international travelers — Bali to Raja
            Ampat, one quiet itinerary at a time.
          </p>

          <div className="mt-8">
            <div className="text-[11px] font-semibold uppercase tracking-[0.3em] text-seafoam mb-3">
              Follow us
            </div>
            <SocialIcons
              variant="light"
              compact={false}
              size={18}
              testidPrefix="footer-social"
            />
          </div>
        </div>

        {/* Explore */}
        <div className="md:col-span-3">
          <div className="text-[11px] font-semibold uppercase tracking-[0.3em] text-seafoam mb-5">
            Explore
          </div>
          <ul className="space-y-3 text-sm text-white/75">
            <li><Link to="/tours" className="hover:text-white transition-colors">Tours</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">Journal</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About us</Link></li>
            <li><Link to="/consultations" className="hover:text-white transition-colors">Consultations</Link></li>
            <li><Link to="/partner" className="hover:text-white transition-colors">Become a Partner</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="md:col-span-4">
          <div className="text-[11px] font-semibold uppercase tracking-[0.3em] text-seafoam mb-5">
            Reach us
          </div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Clock size={16} strokeWidth={1.6} className="text-seafoam shrink-0 mt-0.5" />
              <div>
                <div className="font-medium text-white">Open 24 hours</div>
                <div className="text-white/55 text-xs mt-0.5">Concierge available across all time zones</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.6} className="text-seafoam shrink-0 mt-0.5" />
              <div>
                <div className="font-medium text-white">Office in Yogyakarta</div>
                <div className="text-white/55 text-xs mt-0.5">Daerah Istimewa Yogyakarta, Indonesia</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} strokeWidth={1.6} className="text-seafoam shrink-0 mt-0.5" />
              <a
                href="https://wa.me/6287777881016?text=Halo%20Across%20Indonesia"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp-link"
                className="hover:text-white transition-colors"
              >
                <div className="font-medium text-white">WhatsApp +62 877-7788-1016</div>
                <div className="text-white/55 text-xs mt-0.5">Fastest response</div>
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} strokeWidth={1.6} className="text-seafoam shrink-0 mt-0.5" />
              <a
                href="mailto:win.oktia@gmail.com"
                data-testid="footer-email-link"
                className="hover:text-white transition-colors"
              >
                <div className="font-medium text-white">win.oktia@gmail.com</div>
                <div className="text-white/55 text-xs mt-0.5">Inquiries &amp; partnerships</div>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 px-6 md:px-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/45">
        <span>© {new Date().getFullYear()} Across Indonesia. A bespoke inbound agency.</span>
        <span className="tracking-wider uppercase">Made in Yogyakarta, with care.</span>
      </div>
    </footer>
  );
}
